import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import { Container, Page } from "./elements";
import { SettingsMenu as Menu } from "./menu";
import { SignInAndSecurity } from "./sign-in-and-security";
import { BillingAndPayments } from "./billing-and-payments";
import isEmpty from "lodash.isempty";
import { Router } from "../../../utilities/router";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";

interface MapDispatchProps {}
interface MapStateProps {
  user: Person | null;
}

export type Props = MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { user } = props;
  if (isEmpty(user)) {
    Router.to("/");
  }
  return (
    <Container>
      <Menu />
      <Page>
        <SignInAndSecurity />
        <BillingAndPayments />
      </Page>
    </Container>
  );
};

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {
};

export const AccountController = connect(mapState, mapDispatch)(Component);
